import '../../_feature-components/zoom-image';
import { MeasurementSectionComponent } from './measurement-section.component';
import { runClientComponent } from '../../_common/client/client-component-runner';

runClientComponent({ MeasurementSectionComponent });
